/**
 * 图片 URL 处理（与小程序一致，同一配置双端使用）
 */
const IMAGE_BASE = 'https://wvxvb.cn/images/'

export function getImageUrl(imageName) {
  if (!imageName) return ''
  if (/^https?:\/\//.test(imageName)) return imageName
  const cleanName = (imageName + '').replace(/^\/static\/images\//, '')
  return IMAGE_BASE + cleanName
}

/**
 * 预加载图片（与小程序 utils 行为一致，弱网超时后仍 resolve）
 * @param {string[]} urls
 * @param {{ timeoutMs?: number }} options
 * @returns {Promise<void>}
 */
export function preloadImages(urls, options = {}) {
  const timeoutMs = options.timeoutMs != null ? Number(options.timeoutMs) : 25000
  const list = [...new Set((urls || []).filter(Boolean))]
  if (!list.length) {
    return Promise.resolve()
  }
  const fetchOne = (src) =>
    new Promise((resolve) => {
      const img = new Image()
      img.onload = () => resolve()
      img.onerror = () => resolve()
      img.src = src
    })
  return Promise.race([
    Promise.all(list.map(fetchOne)),
    new Promise((resolve) => setTimeout(resolve, timeoutMs))
  ])
}
